import React, { Fragment, useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { prototypeEntryActions, projectEntryActions } from '@/store';
import { TotalHoursFooter } from '../ProjectEntry/components';
import PrototypeSection from './PrototypeSection.jsx';
import { ProjectEntriesWrapper } from '../ProjectEntry/styled.js';
import { projectEntriesError } from '@/shared';
import PageLoader from '../../components/PageLoader/PageLoader.jsx';
import { handleFetchError } from '../../helpers/toastrUtils.jsx';
import SelectedDaysHeader from '../Home/components/SelectedDaysHeader.jsx';
import TimeBucket from '../TimeBucket/TimeBucket.jsx';
import { isArrayWithLength } from '@/helpers';

const PrototypeTimesheet = () => {
  const dispatch = useDispatch();

  const oid = useSelector(state => state.user.activeUser?.oid);
  const selectedDays = useSelector(state => state.projectEntry.projectEntries.selectedDays);
  const prototypeEntries = useSelector(state => state.prototypeEntry.prototypeEntries);
  const totalHoursByDate = useSelector(state => state.timeBucket.totalHoursByDate);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const shouldRun = oid && isArrayWithLength(selectedDays);
    if (!shouldRun) return;

    const startDate = moment(selectedDays[0]).format('YYYY-MM-DD');
    const endDate = moment(selectedDays[6]).format('YYYY-MM-DD');

    const runAsyncTasks = async () => {
      try {
        await dispatch(projectEntryActions.setupCategories(oid));
        await dispatch(projectEntryActions.requestMonthlyCompletion(oid, moment(selectedDays[0]).format(), 0));
      } catch (e) {
        handleFetchError(e, projectEntriesError);
        return;
      }

      try {
        await dispatch(prototypeEntryActions.getPrototypeTimeEntries(oid, startDate, endDate));
      } catch (e) {
        handleFetchError(e, projectEntriesError);
      }
    };

    setLoading(true);
    runAsyncTasks().then(x => setLoading(false));
  }, [oid, selectedDays]);

  const totalHours = useMemo(() => {
    const weekdates = selectedDays.map(date => moment(date).format('YYYY-MM-DD'));
    const projectSums = Array(7).fill(0);

    prototypeEntries.data.forEach(prototype => {
      prototype.parts.forEach(part => {
        part.processes.forEach(process => {
          process.timeEntries.forEach(entry => {
            const entryDate = entry.timeEntry.entryDate; // Assuming entry.timeEntry.date is in YYYY-MM-DD format
            const dateIndex = weekdates.indexOf(entryDate);

            if (weekdates.indexOf(entryDate) !== -1) {
              projectSums[dateIndex] += entry.timeEntry.hours || 0;
            }
          });         
        });    
      })
    });

    totalHoursByDate && Object.keys(totalHoursByDate).forEach(key => {
      const categorySums = totalHoursByDate[key];
      Object.keys(categorySums).forEach(date => {
        const dateIndex = weekdates.indexOf(date);
        if (dateIndex !== -1) {
          projectSums[dateIndex] += categorySums[date] || 0;
        }
      });      
    });

    return projectSums;
  }, [prototypeEntries.data, selectedDays, totalHoursByDate])

  return (
    <Fragment>
      {(!loading && !prototypeEntries.isLoading) ? (
        <>
          <SelectedDaysHeader />
         
          <ProjectEntriesWrapper>
            {prototypeEntries.data.sort((a, b) => a.requestNumber - b.requestNumber).map((prototype) => <PrototypeSection prototype={prototype} key={prototype.requestId} />)}
          </ProjectEntriesWrapper>
         
          <TimeBucket />         

          <TotalHoursFooter totalHours={totalHours} applyDeletableRowStyles="true" />
        </>
      ) : (
        <PageLoader />
      )}
    </Fragment>
  )
}

export default PrototypeTimesheet;